import * as React from 'react'
function SvgBank(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M10 20v12h4V20h4v12h4V20h4v12h4V20h4v12h2v4H4v-4h2V20h4zm9.2-15.8c.6-.2 1-.2 1.6 0l14 6c.8.2 1.2 1 1.2 1.8v4c0 1.2-.8 2-2 2H6c-1.2 0-2-.8-2-2v-4c0-.8.4-1.6 1.2-1.8zM20 10c-1.2 0-2 .8-2 2s.8 2 2 2 2-.8 2-2-.8-2-2-2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgBank
